export const INITIAL_FORM_DATA = {
  nom: '',
  prenom: '',
  telephone: '',
  dateNaissance: '',
  ville: '',
  quartier: '',
  posteSouhaite: {
    plomberie: false,
    peinture: false,
    electricite: false,
    froidClimatisation: false,
    autre: false,
  },
  autreDomaine: '',
  niveauScolarisation: '',
  formationProfessionnelle: '',
  anneesExperience: '',
  niveauCompetence: '',
  lecturePlans: '',
  capaciteInstructions: '',
  materielTravail: '',
  disponibiliteJours: '',
  smartphone: '',
  accesInternetMobile: '',
  moyenDeplacement: '',
  autreMoyenDeplacement: '',
  disponibilitePreference: {
    joursOuvrables: false,
    soirs: false,
    weekend: false,
  },
};

export function ageFromBirthDate(birthDate) {
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age -= 1;
  return age;
}

export function validateCandidatureForm(formData) {
  const newErrors = {};
  const phoneRegex = /^[0-9+\-\s()]+$/;

  if (!formData.nom.trim()) newErrors.nom = 'Le nom est obligatoire';
  if (!formData.prenom.trim()) newErrors.prenom = 'Le prénom est obligatoire';

  if (!formData.telephone.trim()) {
    newErrors.telephone = 'Le numéro de téléphone est obligatoire';
  } else if (!phoneRegex.test(formData.telephone)) {
    newErrors.telephone = 'Format de téléphone invalide';
  }

  if (!formData.dateNaissance.trim()) {
    newErrors.dateNaissance = 'La date de naissance est obligatoire';
  } else {
    const birthDate = new Date(formData.dateNaissance);
    const age = ageFromBirthDate(birthDate);
    if (Number.isNaN(birthDate.getTime()) || age < 18 || age > 65) {
      newErrors.dateNaissance = 'Âge hors plage autorisée (18–65 ans)';
    }
  }

  if (!formData.ville.trim()) newErrors.ville = 'La ville est obligatoire';
  if (!formData.quartier.trim()) newErrors.quartier = 'Le quartier est obligatoire';

  const postesSelectionnes = Object.values(formData.posteSouhaite).some((val) => val === true);
  if (!postesSelectionnes) {
    newErrors.posteSouhaite = 'Veuillez sélectionner au moins un poste';
  }
  if (formData.posteSouhaite.autre && !formData.autreDomaine.trim()) {
    newErrors.autreDomaine = 'Veuillez préciser le domaine technique';
  }

  if (!formData.niveauScolarisation) {
    newErrors.niveauScolarisation = 'Veuillez sélectionner votre niveau de scolarisation';
  }
  if (!formData.formationProfessionnelle) {
    newErrors.formationProfessionnelle =
      'Veuillez sélectionner une option concernant votre formation professionnelle';
  }
  if (!formData.anneesExperience) {
    newErrors.anneesExperience = "Veuillez sélectionner votre nombre d'années d'expérience";
  }
  if (!formData.niveauCompetence) {
    newErrors.niveauCompetence = 'Veuillez évaluer votre niveau de compétence pratique';
  }
  if (!formData.lecturePlans) {
    newErrors.lecturePlans = 'Veuillez répondre à la question concernant la lecture de plans';
  }
  if (!formData.capaciteInstructions) {
    newErrors.capaciteInstructions = 'Veuillez évaluer votre capacité à suivre des instructions';
  }
  if (!formData.materielTravail) {
    newErrors.materielTravail = 'Veuillez répondre à la question concernant votre matériel de travail';
  }
  if (!formData.disponibiliteJours.trim()) {
    newErrors.disponibiliteJours = 'Veuillez indiquer votre disponibilité en jours';
  }
  if (!formData.smartphone) {
    newErrors.smartphone = 'Veuillez répondre à la question concernant votre smartphone';
  }
  if (!formData.accesInternetMobile) {
    newErrors.accesInternetMobile = 'Veuillez répondre à la question concernant votre accès Internet';
  }
  if (!formData.moyenDeplacement) {
    newErrors.moyenDeplacement = 'Veuillez indiquer votre moyen de déplacement';
  }
  if (formData.moyenDeplacement === 'autre' && !formData.autreMoyenDeplacement.trim()) {
    newErrors.autreMoyenDeplacement = 'Veuillez préciser votre moyen de déplacement';
  }

  const hasPreference = Object.values(formData.disponibilitePreference).some((val) => val === true);
  if (!hasPreference) {
    newErrors.disponibilitePreference = 'Veuillez sélectionner au moins une préférence de disponibilité';
  }

  return newErrors;
}

export function buildCandidaturePayload(formData, { honeypot, captchaToken }) {
  return {
    nom: formData.nom,
    prenom: formData.prenom,
    telephone: formData.telephone,
    dateNaissance: formData.dateNaissance,
    ville: formData.ville,
    quartier: formData.quartier,
    posteSouhaite: {
      plomberie: !!formData.posteSouhaite.plomberie,
      peinture: !!formData.posteSouhaite.peinture,
      electricite: !!formData.posteSouhaite.electricite,
      froidClimatisation: !!formData.posteSouhaite.froidClimatisation,
      autre: !!formData.posteSouhaite.autre,
      autreTexte: formData.autreDomaine || '',
    },
    niveauScolarisation: formData.niveauScolarisation,
    formationProfessionnelle: formData.formationProfessionnelle,
    anneesExperience: formData.anneesExperience,
    niveauCompetence: formData.niveauCompetence,
    lecturePlans: formData.lecturePlans,
    capaciteInstructions: formData.capaciteInstructions,
    materielTravail: formData.materielTravail,
    disponibiliteCommencer: formData.disponibiliteJours || '',
    smartphone: formData.smartphone,
    accesInternetMobile: formData.accesInternetMobile,
    moyenDeplacement: formData.moyenDeplacement,
    moyenDeplacementAutre: formData.autreMoyenDeplacement || '',
    disponibilitePreference: {
      joursOuvrables: formData.disponibilitePreference?.joursOuvrables || false,
      soirs: formData.disponibilitePreference?.soirs || false,
      weekend: formData.disponibilitePreference?.weekend || false,
    },
    website: honeypot.website,
    company: honeypot.company,
    captchaToken: captchaToken || undefined,
  };
}
